import { useEffect, useState } from "react";

export const Preloader = () => {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1400);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className={`preloader ${done ? "done" : ""}`} data-testid="preloader">
      <div className="preloader-logo">Swift<span>Marketing</span></div>
      <div className="preloader-bar"><i /></div>
      <div className="preloader-tag">The power behind the pitch</div>
    </div>
  );
};

const LINKS = [
  ["#services", "Services"],
  ["#energy", "Swift Energy"],
  ["#results", "Results"],
  ["#calculator", "Calculator"],
  ["#careers", "Careers"],
  ["#faq", "FAQ"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return (
    <nav className={`nav ${scrolled ? "scrolled" : ""}`} data-testid="main-nav">
      <div className="container nav-inner">
        <a href="#top" className="nav-logo" data-testid="nav-logo">Swift<span>Marketing</span></a>
        <div className={`nav-links ${open ? "open" : ""}`}>
          {LINKS.map(([href, label]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} data-testid={`nav-link-${label.toLowerCase().replace(/\s/g, "-")}`}>{label}</a>
          ))}
          <a href="#qualify" className="nav-cta" onClick={() => setOpen(false)} data-testid="nav-qualify-cta">Check if You Qualify</a>
        </div>
        <button className={`nav-burger ${open ? "open" : ""}`} onClick={() => setOpen(!open)} aria-label="Menu" data-testid="nav-burger">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
};
